<template>
  <v-container fluid>
    <v-layout>
      <v-flex xs12>
        <v-card>
<!--          <v-layout>-->
<!--            <v-spacer>-->
<!--            </v-spacer>-->
<!--            <v-flex xs3>-->
<!--              <v-select-->
<!--                label="Seasons"-->
<!--                item-text="name"-->
<!--                item-value="value"-->
<!--                v-model="season"-->
<!--                :items="seasons"-->
<!--                variant="solo-filled"-->
<!--                solo-->
<!--                hide-checkoffSettlementDetails-->
<!--                return-object-->
<!--                dense-->
<!--              ></v-select>-->
<!--              <label class="custom-form-error grower-error" for="contract"></label>-->
<!--            </v-flex>-->
<!--            <v-flex xs3>-->
<!--              <v-select-->
<!--                label="Sales"-->
<!--                item-text="name"-->
<!--                item-value="value"-->
<!--                v-model="sale"-->
<!--                :items="sales"-->
<!--                variant="solo-filled"-->
<!--                solo-->
<!--                hide-checkoffSettlementDetails-->
<!--                return-object-->
<!--                dense-->
<!--              ></v-select>-->
<!--              <label class="custom-form-error grower-error" for="contract"></label>-->
<!--            </v-flex>-->
<!--            <v-flex xs3>-->
<!--              <v-btn color="#7BC243" @click="getNceLevyReport()" class="white&#45;&#45;text cataloguebtn">Submit </v-btn>-->
<!--            </v-flex>-->
<!--            <v-spacer>-->
<!--            </v-spacer>-->
<!--            &lt;!&ndash;              <v-flex xs3>-->
<!--                            <v-text-field label="Search" v-model="search">-->
<!--                            </v-text-field>-->
<!--                          </v-flex>&ndash;&gt;-->
<!--          </v-layout>-->
          <v-layout>
            <v-flex xs3>
              <span class="accent--text" style="font-size: 18px; font-weight:700;"> NCE Levy Report </span>
            </v-flex>
            <v-spacer>
            </v-spacer>
            <v-flex xs3>
              <v-btn color="primary" @click="exportToExcel" style="margin-top: 10px;">Export to Excel</v-btn>
            </v-flex>
            <v-spacer>
            </v-spacer>
            <v-flex xs3>
              <v-text-field v-model="search" append-icon="search" label="Search"
                            single-line hide-details color="primary"></v-text-field>
            </v-flex>
          </v-layout>
          <v-data-table
            :headers="headers"
            :items="levies"
            class="elevation-1"
            :search="search"
            :options.sync="pagination"
            :items-per-page="itemsPerPage"
            :hide-default-footer="false"
            :item-key="(item, index) => index"
          >
            <template v-slot:[`header.buyerName`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.brokerName`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.invoiceId`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.amountPaid`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.brokerLevy`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.buyerLevy`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
            <template v-slot:[`header.rate`]="{ header }">
              <span class="font-weight-black primary--text"> {{ header.text.toUpperCase() }} </span>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import config from '../../../config'
import axios from 'axios'
import * as XLSX from 'xlsx'
import http from '@/http'

export default {
	name: 'nceLevyReport',
	data: function () {
		return {
			headers: [
				{ text: 'ESLIP NUMBER', value: 'eslipNumber' },
				{ text: 'BUYER NAME', value: 'buyerName' },
				{ text: 'BROKER NAME', value: 'brokerName' },
				{ text: 'INVOICE ID', value: 'invoiceId' },
				{ text: 'INVOICE AMOUNT', value: 'invoiceAmount' },
				{ text: 'AMOUNT PAID', value: 'invoiceAmount' },
				{ text: 'BROKER LEVY AMOUNT', value: 'brokerLevy' },
				{ text: 'BUYER LEVY AMOUNT', value: 'buyerLevy' },
				{ text: 'RATE', value: 'rate' }
			],
			levies: [],
			message: '',
			error: '',
			loading: true,
			totalOrganizations: 0,
			snackbarColor: '',
			snackbar: false,
			permissions: [],
			search: '',
			editDialog: false,
			valid: true,
			startDateMenu: false,
			startDate: null,
			institutionTypes: [],
			e1: 1,
			currencies: [],
			page: 1,
			totalPages: 0,
			pageSize: 5,
			pageSizes: [5, 10],
			paginatedItems: [],
			numberOfLinks: 0,
			numberOfItemsPerPage: 7,
			generatedOrganizations: [],
			genpaginatedItems: [],
			genNumberOfLinks: 0,
			generatedOrganizationsPage: 1,
			sale: '',
			sales: [],
			season: '',
			seasons: []
		}
	},
	mounted () {
		// this.getSeasons()
		this.getNceLevies()
	},
	methods: {
		getNceLevies: function () {
			const url = config.serverURI + '/reports/nce-levy-report'
			axios.get(url)
				.then(response => {
					const items = response.data
					items.forEach(item => {
						item.invoiceAmount = this.truncateDecimal(item.invoiceAmount)
						item.amountPaid = this.truncateDecimal(item.amountPaid)
						item.brokerLevy = this.truncateDecimal(item.brokerLevy)
						item.buyerLevy = this.truncateDecimal(item.buyerLevy)
					})
					this.levies = items
					// this.totalPages = totalPages
				})
				.catch(error => {
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response.data ? error.response.data.message : 'Error ocurred' })
				})
			return this.levies
		},
		exportToExcel () {
			const exportData = this.levies.map(transaction => ({
				'ESLIP NUMBER': transaction.eslipNumber,
				'BUYER NAME': transaction.buyerName,
				'BROKER NAME': transaction.brokerName,
				'INVOICE NUMBER': transaction.invoiceId,
				'INVOICE AMOUNT': transaction.invoiceAmount,
				'AMOUNT PAID': transaction.invoiceAmount,
				'BROKER LEVY AMOUNT': transaction.brokerLevy,
				'BUYER LEVY AMOUNT': transaction.buyerLevy,
				RATE: transaction.rate
			}))
			const worksheet = XLSX.utils.json_to_sheet(exportData)
			const workbook = XLSX.utils.book_new()
			XLSX.utils.book_append_sheet(workbook, worksheet, 'nceLevyData')
			const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
			this.saveExcelFile(excelBuffer, 'nce_levy_report.xlsx')
		},
		saveExcelFile (buffer, fileName) {
			const data = new Blob([buffer], { type: 'application/octet-stream' })
			const url = window.URL.createObjectURL(data)
			const a = document.createElement('a')
			a.href = url
			a.download = fileName
			a.click()
			window.URL.revokeObjectURL(url)
		},
		truncateDecimal (value) {
			if (!isNaN(value)) {
				// Check if the number is a whole number
				if (Number.isInteger(value)) {
					return value.toString() // Return as a string to avoid displaying trailing .00
				} else {
					return parseFloat(value).toFixed(2) // Truncate to 2 decimal places
				}
			}
			return value
		},
		getSeasons () {
			http.get(config.serverURI + '/miller/findSeasons')
				.then(response => {
					console.log('seasons => ', response.data)
					response.data.forEach((x) => {
						this.seasons.push({
							name: x,
							value: x
						})
					})
					this.getSales()
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		getSales () {
			http.get(config.serverURI + '/miller/findSales')
				.then(response => {
					console.log('sales => ', response.data)
					response.data.forEach((x) => {
						this.sales.push({
							name: x,
							value: x
						})
					})
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', { snackbar: true, color: 'error', message: error.response ? error.response.data.message : 'Error ocurred' }, { root: true })
				})
		},
		getNceLevyReport () {
			console.log(this.sale)
			console.log(this.season)

			if (this.sale === '' || this.season === '') {
				this.message = 'Please select both season and sale'
				this.snackbar = true
				this.snackbarColor = 'error'
				return
			}
			this.findNceLevyReport(this.season.name, this.sale.name)
		},
		findNceLevyReport (season, sale) {
			http.get(config.serverURI + '/reports/nce-levy-report-by-filter?season=' + season + '&sale=' + sale)
				.then(response => {
					console.log('nce-levy-report-by-filter -> ', response.data)
					const items = response.data
					items.forEach(item => {
						item.invoiceAmount = this.truncateDecimal(item.invoiceAmount)
						item.amountPaid = this.truncateDecimal(item.amountPaid)
						item.brokerLevy = this.truncateDecimal(item.brokerLevy)
						item.buyerLevy = this.truncateDecimal(item.buyerLevy)
					})
					this.levies = items
				})
				.catch(error => {
					console.log('error', error)
					this.$store.dispatch('alert/displayAlert', {
						snackbar: true,
						color: 'error',
						message: error.response ? error.response.data.message : 'Error ocurred'
					}, { root: true })
				})
		}
	}
}
</script>

<style scoped>

</style>
